import colors from "common/constants/colorsOld";
import { FontId } from "common/constants/textFont";
import type { SheetPixels } from "common/types/nominalNumbersTypes";
import { sheetInchesToPixels, sheetPixelsNew } from "common/utils/nominalNumbers";
import {
  DEFAULT_EXTRALARGE_FONT_SIZE,
  DEFAULT_LARGE_FONT_SIZE,
  DEFAULT_MEDIUM_FONT_SIZE,
  DEFAULT_MEDIUMLARGE_FONT_SIZE,
  DEFAULT_REGULAR_FONT_SIZE,
  DEFAULT_SMALL_FONT_SIZE,
} from "pdf/planFonts";

export const baseStyleDefault: Required<BaseStyleProps> = {
  //fonts
  fontFamily0: FontId.ArialNarrow, //gets replaced in fontcallback in svgToPdf method

  //after adjusting for pdf scale:
  //  there are - 136 font points in an inch for Arial
  //            - 100 pixels in an inch for svg geometry

  smallFontSize: sheetInchesToPixels(DEFAULT_SMALL_FONT_SIZE),
  regSmallFontSize: sheetPixelsNew(10.5), // TODO - this is an outlier - can we remove?
  regularFontSize: sheetInchesToPixels(DEFAULT_REGULAR_FONT_SIZE),
  mediumFontSize: sheetInchesToPixels(DEFAULT_MEDIUM_FONT_SIZE),
  mediumLargeFontSize: sheetInchesToPixels(DEFAULT_MEDIUMLARGE_FONT_SIZE),
  largeFontSize: sheetInchesToPixels(DEFAULT_LARGE_FONT_SIZE),
  extraLargeFontSize: sheetInchesToPixels(DEFAULT_EXTRALARGE_FONT_SIZE),

  //strokes
  ultraSmallStrokeWidth: sheetPixelsNew(0.25),
  extraSmallStrokeWidth: sheetPixelsNew(0.75),
  smallStrokeWidth: sheetPixelsNew(1),
  highlightStrokeWidth: sheetPixelsNew(1.5),
  hashMarkStrokeWidth: sheetPixelsNew(1.5),
  regularStrokeWidth: sheetPixelsNew(2),
  mediumStrokeWidth: sheetPixelsNew(3),
  textStrokeWidth: sheetPixelsNew(2),

  //colors
  strokeHalfTonePrimary: colors.stone,
  strokeDarkPrimary: colors.black,
  fillLightPrimary: colors.white,
  fillDarkPrimary: colors.black,
  textFillPrimary: colors.black,
  textStrokePrimary: colors.white,
};

export const baseAnnoDefault: Required<BaseAnnoProps> = {
  x: 0,
  y: 0,
  scale: 1,
  rotate: 0,
};

export interface BaseStyleProps {
  //fonts
  fontFamily0?: FontId;

  smallFontSize?: SheetPixels;
  regSmallFontSize?: SheetPixels;
  regularFontSize?: SheetPixels;
  mediumFontSize?: SheetPixels;
  mediumLargeFontSize?: SheetPixels;
  largeFontSize?: SheetPixels;
  extraLargeFontSize?: SheetPixels;

  //strokes
  ultraSmallStrokeWidth?: SheetPixels;
  extraSmallStrokeWidth?: SheetPixels;
  smallStrokeWidth?: SheetPixels;
  regularStrokeWidth?: SheetPixels;
  highlightStrokeWidth?: SheetPixels;
  mediumStrokeWidth?: SheetPixels;
  textStrokeWidth?: SheetPixels;

  hashMarkStrokeWidth?: SheetPixels;

  //colors
  strokeHalfTonePrimary?: string;
  strokeDarkPrimary?: string;
  fillLightPrimary?: string;
  fillDarkPrimary?: string;
  textFillPrimary?: string;
  textStrokePrimary?: string;
}

export interface BaseAnnoProps {
  x?: number;
  y?: number;
  scale?: number;
  rotate?: number;
}
